import React from 'react'
import './modal.new.scss'
import classNames from 'classnames'
import { Typography } from '@mui/material'

interface ModalProps {
    children: React.ReactNode
    title?: string | React.ReactNode
    onDismiss?: () => void
    className?: string
    duoTone?: boolean
}

export const ModalHeader: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    return <div className="modal-header">{children}</div>
}

export const ModalBody: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    return <div className="modal-body">{children}</div>
}

export const ModalFooter: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    return <div className="modal-footer">{children}</div>
}

export const Modal: React.FC<ModalProps> = ({ children, title, onDismiss, className, duoTone }: ModalProps) => (
    <div className="modal-container">
        <div className="overlay" />
        <div className={classNames('modal', className, { 'duo-tone': duoTone })}>
            {title && (
                <ModalHeader>
                    <Typography className="modal-title" variant="h4">
                        {title}
                    </Typography>
                    <div className="modal-close-button" onClick={onDismiss}>
                        &times;
                    </div>
                </ModalHeader>
            )}
            {children}
        </div>
    </div>
)
